import React from 'react';

import { useEventPageContext } from 'app/fan/context/EventPage';

import { BuyFlowTicketsUnavailableContainer } from './BuyFlowTicketsUnavailableContainer';

export const BuyFlowTicketsUnavailableEventPage = () => {
  const { event } = useEventPageContext();

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event) {
    return null;
  }

  return <BuyFlowTicketsUnavailableContainer />;
};
1;
